// src/Components/useSubmitLog.js
import { useLocation } from "react-router";
import { LogUrl } from "../Config/config";
import { useContext } from "react";
import { UserContext } from "../Contexts/UserContext";
import useModule from "../hooks/useModule";
import axios from 'axios';

const useSubmitLog = () => {
  const { getToken, getUser } = useContext(UserContext);
  const location = useLocation();
  const { mappedPrimaryMasterId } = useModule();

  const submitLog = async (logname) => {
    const payload = {
      mail_id: getUser()?.email,
      module: mappedPrimaryMasterId,
      url: `${window.location.origin}${location.pathname}`,
      logname
    };

    try {
      await axios.post(LogUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": getToken()
        }
      });
      console.log("Log API call successful");
    } catch (error) {
      console.error("Log API call failed", error);
    }
  };

  return submitLog;
};

export default useSubmitLog;
